import { createReducer } from "redux-create-reducer";

import {
  GET_SINGLE_CLIENT_REPORT_ENTRIES,
  GET_SINGLE_CLIENT_REPORT_ENTRIES_COUNT,
  SET_SINGLE_CLIENT_REPORT_ENTRIES_FILTERS,
  SET_SINGLE_CLIENT_REPORT_ENTRIES_CURRENT_PAGE,
  CLEAR_SINGLE_CLIENT_REPORT_ENTRIES,
  SET_ITEMS_PER_PAGE_SINGLE_CLIENT_REPORT,
  SET_COUNT_SINGLE_CLIENT_REPORT,
  SET_NO_ENTRIES_MESSAGE_SINGLE_CLIENT_REPORT,
} from "../../types";

const initialState = {
  data: [],
  filters: {
    firstName: "",
    type: null,
    middleName: "",
    lastName: "",
    fullName: "",
    clientNumber: "",
    clientOfferId: "",
  },
  pageInfo: {
    count: 0,
    itemsPerPage: 10,
    currentPage: 1,
  },
  entries: [],
  isLoading: false,
  noEntriesMessage: "",
  customClientParameters: [],
};

const singleClientReportEntriesReducer = createReducer(initialState, {
  [SET_SINGLE_CLIENT_REPORT_ENTRIES_FILTERS]: (state, { payload }) => ({
    ...initialState,
    clientTypes: state.clientTypes,
    filters: { ...state.filters, ...payload },
  }),
  [SET_SINGLE_CLIENT_REPORT_ENTRIES_CURRENT_PAGE]: (state, { payload }) => ({
    ...state,
    pageInfo: {
      ...state.pageInfo,
      currentPage: payload,
    },
  }),
  [SET_ITEMS_PER_PAGE_SINGLE_CLIENT_REPORT]: (state, { payload }) => ({
    ...state,
    pageInfo: {
      ...state.pageInfo,
      itemsPerPage: payload,
    },
  }),
  [SET_COUNT_SINGLE_CLIENT_REPORT]: (state, { payload }) => ({
    ...state,
    pageInfo: {
      ...state.pageInfo,
      count: payload,
    },
  }),
  [GET_SINGLE_CLIENT_REPORT_ENTRIES_COUNT.DEFAULT]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [GET_SINGLE_CLIENT_REPORT_ENTRIES_COUNT.PENDING]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [GET_SINGLE_CLIENT_REPORT_ENTRIES_COUNT.REJECTED]: (state) => ({
    ...state,
    isLoading: false,
  }),
  [GET_SINGLE_CLIENT_REPORT_ENTRIES_COUNT.FULFILLED]: (state, { payload }) => {
    const hasResults = payload.data > 0;
    return {
      ...state,
      pageInfo: {
        ...state.pageInfo,
        count: payload.data,
      },
      isLoading: hasResults,
    };
  },
  [GET_SINGLE_CLIENT_REPORT_ENTRIES.DEFAULT]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [GET_SINGLE_CLIENT_REPORT_ENTRIES.PENDING]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [GET_SINGLE_CLIENT_REPORT_ENTRIES.REJECTED]: (state) => ({
    ...state,
    isLoading: false,
  }),
  [GET_SINGLE_CLIENT_REPORT_ENTRIES.FULFILLED]: (state, { payload }) => ({
    ...state,
    data: payload.data,
    isLoading: false,
  }),
  [SET_NO_ENTRIES_MESSAGE_SINGLE_CLIENT_REPORT]: (state, { payload }) => {
    return {
      ...state,
      noEntriesMessage: payload,
    };
  },
  [CLEAR_SINGLE_CLIENT_REPORT_ENTRIES]: () => ({ ...initialState }),
});

export default singleClientReportEntriesReducer;



// WEBPACK FOOTER //
// ./src/features/reports/reducers/single-client/singleClientReportEntriesReducer.js